import CreateTableDropdown from './CreateTableDropdown';

export default CreateTableDropdown;